import type { State } from '@/reducers/types';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { retrieveRtag } from './actions';

const rtagsAdapter = createEntityAdapter<any>({
  sortComparer: (a, b) => a.id.localeCompare(b.id),
});

interface RtagsState {
  total: number;
  rtagData: any;
  isRegenerated?: boolean;
  title?: string;
}

const initialState = rtagsAdapter.getInitialState<RtagsState>({
  total: 0,
  rtagData: null,
  isRegenerated: undefined,
  title: undefined,
});

const { name, reducer, actions } = createSlice({
  name: 'rtags',
  initialState,
  reducers: {
    setRtagData(state, action) {
      state.rtagData = action.payload;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(retrieveRtag.fulfilled, (state, action) => {
      if (action.payload && action.payload.type === 'complete') {
        const completeUpdate = action.payload.updates.find(
          (update: any) => update.type === 'chain-success',
        );
        state.rtagData = completeUpdate?.output?.output.answer;
      }
    });
  },
});

const { setRtagData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setRtagData, setTitle };

export const selectRtagData = (state: State) => state[name].rtagData;
export const selectRtagIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectRtagTitle = (state: State) => state[name].title;
